import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

export interface ShortcutCardProps extends FlexProps {
  icon: ReactNode;
  label: ReactNode;
  iconWidth?: string;
  iconHeight?: string;
}

export const ShortcutCard = ({ icon, label, iconWidth = '40px', iconHeight = '40px', ...props }: ShortcutCardProps) => {
  return (
    <Flex
      py='femto'
      direction='column'
      align='center'
      justify='space-between'
      width='100px'
      height='100px'
      borderRadius='card'
      backgroundColor='white'
      cursor='pointer'
      shadow='md'
      {...props}
    >
      <Flex flexGrow={1} align='center'>
        <Flex
          color='brand.500'
          width={iconWidth}
          height={iconHeight}
          justify='center'
          align='center'
          sx={{
            '& > svg, & > img': {
              width: 'full',
              height: 'full',
              preserveAspectRatio: 'xMidYMid meet',
              objectFit: 'contain',
            },
          }}
        >
          {icon}
        </Flex>
      </Flex>

      <Flex height='30px' align='center'>
        <Text fontSize='12px' color='text.main' fontWeight='bold' textAlign='center' lineHeight='15px'>
          {label}
        </Text>
      </Flex>
    </Flex>
  );
};
